import { TextBoxShapeProps } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/Types'
import Styles from './TextStylesDrawer.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { TEXT_PRESETS } from '../TextTab/constants'
import { Pressable } from '@react-aria/interactions'
import { TextPresetThumbnail } from '../TextTab/TextPresetThumbnail'

interface Props {
  onSelect: (newProps: Partial<TextBoxShapeProps>) => any
}

export const PresetTextStyles = ({ onSelect }: Props) => (
  <div className={Styles.section}>
    <Text variant="largeList">All Styles</Text>
    <div className={Styles.presetsGrid}>
      {TEXT_PRESETS.map((preset, i) => (
        <Pressable
          key={i}
          onPress={() => {
            onSelect(preset.props)
          }}
        >
          <div>
            <TextPresetThumbnail preset={preset} />
          </div>
        </Pressable>
      ))}
    </div>
  </div>
)
